/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Material_Split_Negative_HintInputs */

const vi_order_material_split_negative_hint = /** @type {(inputs: Order_Material_Split_Negative_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá vật tư vượt giá sản phẩm — kiểm tra lại cấu hình`)
};

/**

* @param {Order_Material_Split_Negative_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_material_split_negative_hint = /** @type {((inputs?: Order_Material_Split_Negative_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Material_Split_Negative_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_material_split_negative_hint(inputs)
});